import Vue from 'vue';
import SwitchUser from './components/global/SwitchUser';
import SwitchUserModalInfo from './components/global/SwitchUserModal';

if (document.getElementById('switchUser')) {
  new Vue({
    name: 'SwitchUser',
    el: '#switchUser',
    template: '<SwitchUser />',
    components: {
      SwitchUser,
    },
  });
}

if (document.getElementById('switchUserModal')) {
  new Vue({
    name: 'SwitchUserModalInfo',
    el: '#switchUserModalInfo',
    template: '<SwitchUserModalInfo />',
    components: {
      SwitchUserModalInfo,
    },
  });
}
